module.exports = __webpack_public_path__ + "static/img/bottom-banner.f93f3c7e.png";